import { TAB_VALIDATION } from "../../constants/tabValidation";

const initialState = {}

export const vaidationReducer = (state = initialState, action) => {
    switch (action.type) {
        case TAB_VALIDATION:
            return { ...state,  ...action.payload }
        default:
            return state
    }
}